import QueriesRenderer from './QueriesRenderer';

export default QueriesRenderer;
